import(/* webpackMode: "eager" */ "/vercel/path0/app/_client/ClientSetup.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Footer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Navbar.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css")